import api from "./api";

export const getEscalatedReports = () => {
  return api.get(`/partners/assets/escalated-reports`);
};
